// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1fRSI","content":"LoadingAlert_content__2T61e"};